import { useMemo } from 'react';
import DataStoreOptions from './DataStoreOptions';
import useQueries from './useQueries';
import createDataStore from './createDataStore';

const useDataStore = <T>(options: DataStoreOptions<T>) => {
  const queries = useQueries<T>(options);

  // Exclude expandedParentIds from useMemo deps so the store is NOT recreated when
  // the user expands/collapses groups. Use getExpandedParentIds getter instead for
  // live reads inside load().
  const { filter, expandedParentIds: _expandedParentIds, ...opt } = options;

  const dataStore = useMemo(
    () => createDataStore<T>(queries, options),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [queries, JSON.stringify(filter || []), ...Object.values(opt)],
  );
  return dataStore;
};

export default useDataStore;
